import React, { Component } from 'react';
import API from '../api.js';
import { Navbar } from 'react-bootstrap';
import EZCLogoImg from '../images/logo_64.png'
import GroupLogoImg from '../images/logo005.png'
import { Cookies, withCookies } from 'react-cookie';

export default withCookies(function CustomerHeaderFooter(props) {
    let tmp = props.cookies.get('usr');
    const userData = (tmp == "undefined") ? null : tmp;
    const pointData = props.cookies.get('point');

    function render() {
        return (
            <>
                <Navbar sticky="top" variant="light" bg={"EZC"}>
                    <Navbar.Brand>
                        {/* <img src={EZCLogoImg} /> */}
                        9EZ!</Navbar.Brand>
                    <Navbar.Toggle />
                    <Navbar.Collapse className="justify-content-end">
                        <Navbar.Text className="no-selection">
                            {(userData ? "Hi " + userData + (pointData ? ", " + pointData + "點" : "") : "")}
                            {/* Hi <a href="#login">{userData ? userData : ""}</a> */}
                        </Navbar.Text>
                    </Navbar.Collapse>
                </Navbar>

                {/* <Navbar fixed="bottom" variant="light" bg={"EZC"}>
                    <Navbar.Brand>
                        <img src={GroupLogoImg} />
                    </Navbar.Brand>
                    <Navbar.Text>@2021 All Rights Reserved.</Navbar.Text>
                </Navbar> */}
            </>
        );
    }
    return render();
})